export var SpinnerSize;

(function (SpinnerSize) {
  SpinnerSize["ExtraSmall"] = "xs";
  SpinnerSize["Small"] = "s";
  SpinnerSize["Medium"] = "m";
  SpinnerSize["Large"] = "l";
})(SpinnerSize || (SpinnerSize = {}));

export var SpinnerColorScheme;

(function (SpinnerColorScheme) {
  SpinnerColorScheme["Default"] = "default";
  SpinnerColorScheme["Inverted"] = "inverted";
})(SpinnerColorScheme || (SpinnerColorScheme = {}));